module.exports = __webpack_public_path__ + "img/eyemask.887a1b29.gif";